import { getLossStockNameList } from "@/api/Loss.js";
import MobileOrder from "../MobileOrder.vue";
export default {
  components: {
    MobileOrder
  },
  data() {
    return {
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      breadCrumbItems: [],
      currentBreadCrumbIndex: 0,
      breadCrumbId: 0,
      productDetailActive: false,
      stocks: [],
      stockNameFilter: null,
      filteredStocks: [],
      newOrder: false,
      orderQuantity:0,
      orderListIsActive: false,
    };
  },
  props: {
    productList: null,
  },
  computed: {
    hasNeedNavigationByQuestion() {
      return this.$store.getters["selfservice/hasNeedNavigationByQuestion"];
    },
    hasAnySelectedStockLoss() {
      let bool = this.stocks.some((x) => x.isSelected);
      return !bool;
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    productNavResetEpoch() {
      return this.$store.getters["selfservice/getProductNavResetEpoch"];
    },
    currentProductList() {
      if (this.productList == null) {
        return [];
      }
      if (this.breadCrumbItems.length === 0) {
        return [];
      }
      const crumb = this.breadCrumbItems[this.currentBreadCrumbIndex];
      const raw = crumb.dataSet;
      if (!raw || raw.length === 0) {
        return [];
      }
      // Yalnızca kategori içi ürün listesi; kök / alt kategori grid'i API sırasıyla kalır
      if (crumb.listKind !== "products") {
        return raw;
      }
      return [...raw].sort((a, b) =>
        String(a.name || "").localeCompare(String(b.name || ""), "tr", {
          sensitivity: "base",
        })
      );
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
  },
  watch: {
    hasNeedNavigationByQuestion(val) {
      if(val) {
        this.navigateByQuestion()
      }
    },
    stockNameFilter(val) {
      this.setStockFilter(val);
    },
    lossMode(val) {
      if (val) {
        if (this.stocks.length > 0) return;
        this.getLossStockNameList();
      }
    },
    productNavResetEpoch() {
      this.applyResetLocalUi();
      this.$nextTick(() => {
        const el =
          typeof this._getProductScrollEl === "function"
            ? this._getProductScrollEl()
            : null;
        if (el && typeof el.scrollTop === "number") {
          el.scrollTop = 0;
        }
      });
    },
    selectedLossStocks: {
      deep: true,
      handler(val) {
        let selectedStocks = this.stocks.filter((x) => x.isSelected);
        if (val && val.length == 0) {
          selectedStocks.forEach((x) => {
            x.isSelected = false;
            x.quantity = null;
          });
        } else if (
          val &&
          val.length > 0 &&
          val.length < selectedStocks.length
        ) {
          selectedStocks.forEach((x) => {
            if (!val.some((y) => y.id == x.id)) {
              x.isSelected = false;
              x.quantity = null;
            }
          });
        }
      },
    },
  },
  created: async function () {
    // Get the initial order quantity
    this.updateOrderQuantity();
  },
  inject: {
    refreshOrderQuantity: { default: null },
    getOrderQuantity: { default: null },
    hasNewOrder: { default: null },
    resetNewOrder: { default: null },
    closeCartIfOpen: { default: () => function () {} },
  },
  mounted: function () {
    // Initialize component without creating a new SignalR connection
    this.initializeComponent();
  },
  methods: {
    /** Breadcrumb ve zayiat stok grid’i; Vuex temizliği finalizeSuccessfulSelfServiceOrder’da. */
    applyResetLocalUi() {
      if (this.breadCrumbItems && this.breadCrumbItems.length > 0) {
        this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      }
      if (this.stocks.length > 0) {
        this.stocks.forEach((x) => {
          x.quantity = null;
          x.isSelected = false;
        });
      }
    },
    updateOrderQuantity: async function () {
      // Use the injected method
      await this.refreshOrderQuantity();
      this.orderQuantity = await this.getOrderQuantity();
      this.newOrder = this.hasNewOrder();
    },
    openMobileOrders(){
      this.resetNewOrder();
      this.newOrder = false;
      this.orderListIsActive = true;
      if (this.$refs.mobileOrder) {
        try {
          this.$refs.mobileOrder.getOrder();
        } catch (error) {
          console.error("Error calling getOrder:", error);
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Siparişler yüklenirken bir sorun oluştu."
          });
        }
      } else {
        console.error("mobileOrder reference is not available");
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Sipariş komponenti bulunamadı."
        });
      }
    },
    setStockSelect(stock) {
      stock.isSelected = true;
      this.$store.dispatch("selfservice/addSelectedLossStock", stock);
    },
    setStockFilter: _.debounce(function (val) {
      this.filteredStocks = this.stocks.filter((x) =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
    }, 500),
    getLossStockNameList() {
      getLossStockNameList()
        .then((res) => {
          if (res && res.status) {
            this.stocks = res.data;
            this.setStockFilter("");
          } else {
            this.$fire({
              title: "Hata : " + res.status,
            text: "Stok Listesi Bulunamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
            });
          }
        })
        .catch((error) => {
          this.$fire({
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
          });
        });
    },
    /** Kaydırma alanı artık üstteki .product-list-scroll (dataList overflow taşımıyor) */
    _getProductScrollEl() {
      const inner = document.getElementById("dataList");
      if (inner && typeof inner.closest === "function") {
        const wrap = inner.closest(".product-list-scroll");
        if (wrap) return wrap;
      }
      return document.querySelector(".product-list-scroll");
    },
    scrollTop() {
      const el = this._getProductScrollEl();
      if (!el) return;
      el.scrollBy({ top: -120, behavior: "smooth" });
    },
    scrollDown() {
      const el = this._getProductScrollEl();
      if (!el) return;
      el.scrollBy({ top: 120, behavior: "smooth" });
    },
    checkChildren: function (product) {
      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          return product.children[0].price.toString() + "₺";
        }
      }
      return null;
    },

    initializeComponent: async function () {
      this.breadCrumbItems = [
        {
          name: "Kategoriler",
          id: this.breadCrumbId++,
          dataSet: this.productList,
          listKind: "categories",
        },
      ];
    },
    navigateByQuestion() {
      try {
        if (typeof this.closeCartIfOpen === "function") {
          this.closeCartIfOpen();
        }
        const navigationQuestion =
          this.$store.getters["selfservice/getNavigationQuestion"] || {};
        const categoryId =
          navigationQuestion.categoryId != null
            ? navigationQuestion.categoryId
            : navigationQuestion.CategoryId;
        const productId =
          navigationQuestion.productId != null
            ? navigationQuestion.productId
            : navigationQuestion.ProductId;

        this.onClickBreadCrumb(this.breadCrumbItems[0], 0);

        const pastaCategoryName = "Pasta ve Kekler";

        if (categoryId != null && categoryId !== "") {
          let category = this.currentProductList.find((x) => x.id == categoryId);
          if (!category) {
            category = this.currentProductList.find(
              (x) =>
                x.name &&
                x.name.trim().toLowerCase() === pastaCategoryName.toLowerCase()
            );
          }
          if (category) {
            this.onProductDetailClick(category);
            this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
          }
        }

        if (productId != null && productId !== "") {
          const product = this.currentProductList.find((x) => x.id == productId);
          if (product) {
            this.onProductDetailClick(product);
            this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.$store.dispatch("selfservice/hasNeedNavigationByQuestion", false);
    },
    onClickBreadCrumb: function (selectedBreadCrumb, index) {
      this.currentBreadCrumbIndex = index;
      this.breadCrumbItems.length = this.currentBreadCrumbIndex + 1;
      this.breadCrumbItems = [...this.breadCrumbItems];
    },
    goBackCategory() {
      if (this.lossMode || this.currentBreadCrumbIndex <= 0) return;
      const prevIndex = this.currentBreadCrumbIndex - 1;
      this.onClickBreadCrumb(this.breadCrumbItems[prevIndex], prevIndex);
    },
    onProductDetailClick: function (product) {
      let breadItem = {
        id: this.breadCrumbId++,
        name: product.name,
      };

      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          product.children[0].isSelected = true;
          this.$store.dispatch("selfservice/productSelectionCompleted", {
            product: product,
            sizeId: product.children[0].sizeId,
          });
          return;
        }
      }

      if (product.childCategories != null) {
        breadItem.dataSet = product.childCategories;
        breadItem.listKind = "categories";
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.products != null) {
        breadItem.dataSet = product.products;
        breadItem.listKind = "products";
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.type) {
        this.SelectProduct(product);
      }
    },
    SelectProduct: function (product) {
      this.$store.dispatch("selfservice/setPreSelectedProduct", product);
    },
  },
};
